import React from "react";
import Icon from "@ant-design/icons";


const UseLocationSvg = () => (
    <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 48 48">
        <path d="M44.13,23.01h-2.55c-.62-8.71-7.58-15.68-16.3-16.3v-2.79c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25,1.25v2.79c-8.71.62-15.68,7.58-16.29,16.3h-2.63c-.69,0-1.25.56-1.25,1.25s.56,1.25,1.25,1.25h2.63c.62,8.71,7.58,15.68,16.29,16.3v2.38c0,.69.56,1.25,1.25,1.25s1.25-.56,1.25-1.25v-2.38c8.71-.62,15.68-7.58,16.3-16.3h2.55c.69,0,1.25-.56,1.25-1.25s-.56-1.25-1.25-1.25ZM25.28,39.3v-3.3c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25,1.25v3.3c-7.33-.6-13.19-6.46-13.79-13.8h3.05c.69,0,1.25-.56,1.25-1.25s-.56-1.25-1.25-1.25h-3.05c.6-7.33,6.46-13.19,13.79-13.8v2.89c0,.69.56,1.25,1.25,1.25s1.25-.56,1.25-1.25v-2.89c7.33.6,13.19,6.46,13.8,13.8h-3.13c-.69,0-1.25.56-1.25,1.25s.56,1.25,1.25,1.25h3.13c-.6,7.33-6.46,13.19-13.8,13.8Z"/>
        <path d="M24.03,15.27c-4.96,0-8.99,4.03-8.99,8.99s4.03,8.99,8.99,8.99,8.99-4.03,8.99-8.99-4.03-8.99-8.99-8.99ZM24.03,30.75c-3.58,0-6.49-2.91-6.49-6.49s2.91-6.49,6.49-6.49,6.49,2.91,6.49,6.49-2.91,6.49-6.49,6.49Z"/>
    </svg>
);

const UseLocationIcon = (props) => (
    <Icon component={ UseLocationSvg } { ...props } />
);

export default UseLocationIcon;
